import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';
import { IMessageParameters } from '#/CoreFrameInterfaces';

interface IAssociationNavigationMessageParameters extends IMessageParameters {
    fromPdoId: string;
    fromPDTypeName: string;
    relation: string;
    toPdoId?: string;
    toPDTypeName: string;
}

export default class AssociationNavigationMessage extends Message {
    public fromPdoId: string;
    public fromPDTypeName: string;
    public relation: string;
    public toPdoId?: string;
    public toPDTypeName: string;

    public constructor(params: IAssociationNavigationMessageParameters) {
        super(params);

        this.fromPdoId = params.fromPdoId;
        this.fromPDTypeName = params.fromPDTypeName;
        this.relation = params.relation;
        this.toPdoId = params.toPdoId;
        this.toPDTypeName = params.toPDTypeName;
    }
}

ComponentManager.setMessage('AssociationNavigationMessage', AssociationNavigationMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');